const CHANGES_UNSAVED = 'Do you really want to leave? you have unsaved changes!';
const WRONG_ID_SUPPLIED = 'There is no element for the provided ID';
const CONFIRM_DELETE = "Are you sure you want to delete this item?";
const CONFIRM_UNASSIGMENT = "Are you sure you want to remove assigment?";

const ALERT_TYPES = {
    "WARNING": 'warning',
    "ERROR": 'error',
    "CONFIRM": 'confirm'
}

export {
    CHANGES_UNSAVED,
    WRONG_ID_SUPPLIED,
    ALERT_TYPES,
    CONFIRM_DELETE,
    CONFIRM_UNASSIGMENT
}